import React from 'react';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { Problem } from './components/Problem';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Pricing } from './components/Pricing';
import { Garantia } from './components/Garantia';
import { FAQ } from './components/FAQ';
import { CostoNoComprar } from './components/CostoNoComprar';
import { CTAFinal } from './components/CTAFinal';
import { Footer } from './components/Footer';
export function App() {
  const testimonialsRow1 = [{
    initials: 'MG',
    quote: 'Empecé a publicar con el método y en dos semanas tuve 3 conversaciones reales por DM sobre fe. Nunca me había pasado.',
    name: '— Marcela G., Córdoba'
  }, {
    initials: 'LP',
    quote: 'Siempre tuve miedo de sonar religiosa. Con este sistema publico con confianza y la gente me responde diferente.',
    name: '— Laura P., Rosario'
  }, {
    initials: 'RM',
    quote: 'Pensé que evangelizar en redes era imposible sin perder seguidores. Me equivoqué completamente.',
    name: '— Roberto M., Buenos Aires'
  }];
  const testimonialsRow2 = [{
    initials: 'CR',
    quote: 'El tomo de DMs me cambió todo. Antes no sabía qué responder cuando alguien me escribía. Ahora tengo conversaciones reales.',
    name: '— Cecilia R., Mendoza'
  }, {
    initials: 'SC',
    quote: 'El planificador anual fue lo que necesitaba. Ya no improviso más. Tengo dirección para todo el año.',
    name: '— Sofía C., La Plata'
  }, {
    initials: 'MV',
    quote: 'Nunca pensé que podía hablar de Dios en Instagram sin perder seguidores. El método Caballo de Troya funciona de verdad.',
    name: '— Mónica V., Tucumán'
  }, {
    initials: 'JL',
    quote: 'Tenía la cuenta abandonada hace meses. Con Misión Influencia la retomé con propósito y ya noto la diferencia.',
    name: '— Jorge L., Rosario'
  }];
  return <div className="min-h-screen bg-base text-text-body font-sans selection:bg-gold selection:text-base" data-id="element-0">
      <TopBar data-id="element-1" />
      <Hero data-id="element-2" />
      <Testimonials items={testimonialsRow1} bgClass="bg-dark" data-id="element-3" />
      <Problem data-id="element-4" />
      <Tomos data-id="element-5" />
      <Bonos data-id="element-6" />
      <Testimonials items={testimonialsRow2} bgClass="bg-light" title={<h2 className="text-[22px] md:text-[34px] font-black text-center text-text-heading" data-id="element-8">
            ❤️ Más <span className="text-gold" data-id="element-9">cristianos argentinos</span> que
            ya lo tienen
          </h2>} data-id="element-7" />
      <Pricing data-id="element-10" />
      <Garantia data-id="element-11" />
      <FAQ data-id="element-12" />
      <CostoNoComprar data-id="element-13" />
      <CTAFinal data-id="element-14" />
      <Footer data-id="element-15" />
    </div>;
}